/**
 * Loader
 */
import CircularProgress from '@mui/material/CircularProgress';
import Typography from '@mui/material/Typography';

const styles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    flex: 1,
    width: '100%',
    height: '100%'
  },
  circle: {
    zIndex: 100000,
    color: '#000'
  },
  message: {
    marginTop: '16px',
  },
};

export default function Loader({ message }) {
  return (
    <div style={styles.container}>
      <CircularProgress size="2rem" style={styles.circle} />
      {
        message &&
        <Typography style={styles.message} color="secondary">
          {message}
        </Typography>
      }
    </div>
  );
}
